const patientSchemaProperties = {
  civilite: {
    title: "patient.civilite",
    type: "string",
  },
  firstname: {
    title: "form:patient.firstname",
    type: "string",
    maxLength: 50,
    isNotEmpty: true,
  },
  lastname: {
    title: "form:patient.lastname",
    type: "string",
    maxLength: 50,
    isNotEmpty: true,
  },
  dateofbirth: {
    title: "form:patient.dateofbirth",
    type: ["string", "null"],
    isNotEmpty: true,
    isNotNull: true,
    format: "date",
  },
  gender: {
    title: "form:patient.gender",
    type: "string",
    isNotEmpty: true,
    isNotNull: true,
  },
  tags: {
    title: "form:patient.tags",
    type: "array",
    uniqueItems: true,
    items: { type: "string" },
  },
  collect_accept: {
    type: "boolean",
  },
  external_ids: {
    type: "array",
    uniqueItems: true,
    items: {
      type: "object",
      properties: {
        service: { type: "string" },
        id: { type: "string" },
      },
    },
  },
  email: {
    title: "form:patient.email",
    type: "string",
    format: "email",
    maxLength: 100,
  },
  phone: {
    title: "form:patient.phone",
    type: "string",
    maxLength: 25,
  },
  adresse1: {
    title: "form:patient.adresse1",
    type: "string",
    maxLength: 100,
  },
  adresse2: {
    title: "form:patient.adresse2",
    type: "string",
    maxLength: 100,
  },
  postcode: {
    title: "form:patient.postcode",
    type: "string",
    maxLength: 100,
  },
  city: {
    title: "form:patient.city",
    type: "string",
    maxLength: 100,
  },
  healthcare_id: {
    title: "form:patient.healthcare_id",
    type: "string",
    maxLength: 50,
  },
  assure_civilite: { type: "string", maxLength: 10 },
  assure_firstname: { type: "string", maxLength: 50 },
  assure_lastname: { type: "string", maxLength: 50 },
  assure_healthcare_id: {
    title: "form:patient.healthcare_id",
    type: "string",
    maxLength: 50,
  },
  assure_dateofbirth: { type: ["string", "null"], format: "date" },
  assure_adresse1: { type: "string", maxLength: 100 },
  assure_adresse2: { type: "string", maxLength: 100 },
  assure_postcode: { type: "string", maxLength: 10 },
  assure_city: { type: "string", maxLength: 100 },
  assure_email: { type: "string", format: "email", maxLength: 100 },
  assure_phone: { type: "string", maxLength: 25 },
  assure_gender: { type: "string", maxLength: 10 },
  is_patient_assure: {
    title: "form:patient.is_patient_assure",
    type: "boolean",
  },
  recontact_date: {
    title: "form:patient.recontact_date",
    type: ["string", "null"],
    format: "date",
  },
  correspondants: {
    type: 'array',
    uniqueItems: true,
    items: {
      type: 'string'
    },
  },
  "traitement-categorie": {
    type: "string",
  },
  caisse: {
    type: ["object", "null"],
  },
};

const patientSchemaRequired = [
  "firstname",
  "lastname",
  "dateofbirth",
  "gender",
  "collect_accept",
  "is_patient_assure",
];

export const patientSchema = {
  title: "Patient",
  type: "object",
  properties: patientSchemaProperties,
  required: patientSchemaRequired,
};

const EXTERNAL_OMIT_FIELDS = [
  'id',
  'tags',
  'collect_accept',
  'external_ids',
  'correspondants',
  'traitement-categorie',
  'recontact_date',
];

const externalPatientProperties = Object.fromEntries(
  Object.entries(patientSchemaProperties).filter(([key]) => !EXTERNAL_OMIT_FIELDS.includes(key))
);

export const externalPatientSchema = {
  title: "ExternalPatient",
  type: "object",
  properties: externalPatientProperties,
  additionalProperties: false,
};

export default patientSchema;
